
@if ((portalUsers.length || ssoUsers.length)) {
  <table class="table">
    <thead>
      <tr>
        <th style="width: 33px"></th>
        <th>Person ID</th>
        <th>Name</th>
        <th>Registration</th>
        <!--<th>Postcode</th>-->
        <th>Email</th>
        <th>myGPhC</th>
        <th>Azure</th>
      </tr>
    </thead>
    <tbody>
      @for (user of portalUsers; track user) {
        <tr (click)="toggleSelectedPortalUser(user)"
          [class.highlighted]="user.personId===highlightedPortalUser?.personId"
          [class.selected]="selectedPortalUser === user">
          <td>
            @if (!user.checkingPortalStatus && user.portalStatus === PortalStatus.Activated) {
              <i class="fa fa-link"></i>
            }
            @if (!user.checkingPortalStatus && user.portalStatus === PortalStatus.Locked) {
              <i class="fa fa-lock"></i>
            }
            @if (!user.checkingPortalStatus && user.portalStatus !== PortalStatus.Locked && user.portalStatus !== PortalStatus.Activated) {
              <i
              class="fa fa-unlink"></i>
            }
          </td>
          <td style="white-space: nowrap">
            <i class="fa fa-user"></i>
            {{user.personId}} {{loadUser}}
          </td>
          <td>{{user.toString()}}</td>
          <td>{{user.registrant?.registrationNumber || '-' }}</td>
          <!--<td>{{user.address?.postcode || '-' }}</td>-->
          <td>{{user.contact?.email || '-' }}</td>
          <td>
            @if (user.checkingPortalStatus) {
              <span>
                <app-spinner [miniscule]="true"></app-spinner>
              </span>
            }
            @if (!user.gettingPortalStatus) {
              <span>
                {{PortalStatus[user.portalStatus] | caseSplit}}
              </span>
            }
          </td>
          <td>
            @if (user.checkingSsoStatus) {
              <span>
                <app-spinner [miniscule]="true"></app-spinner>
              </span>
            }
            @if (!user.checkingSsoStatus) {
              <span>
                {{SsoStatus[user.ssoStatus] | caseSplit}}
              </span>
            }
          </td>
        </tr>
      }
      @for (user of ssoUsers; track user) {
        <tr (click)="toggleSelectedSsoUser(user)"
          [class.highlighted]="user.email===highlightedSsoUser?.email" [class.selected]="selectedSsoUser === user">
          <td>
            @if (user.ssoStatus !== SsoStatus.Locked) {
              <i class="fa fa-unlink"></i>
            }
            @if (user.ssoStatus === SsoStatus.Locked) {
              <i class="fa fa-lock"></i>
            }
          </td>
          <td>-</td>
          <td>-</td>
          <td>-</td>
          <td>{{ user.email }}</td>
          <td>Pending Activation</td>
          <td> {{SsoStatus[user.ssoStatus] | caseSplit}}</td>
        </tr>
      }
    </tbody>
  </table>
}

@if (portalUsers.length || ssoUsers.length) {
  <button class="btn btn-default btn-lg pull-right"
  (click)="clearUserList()">Clear</button>
}

@if (!loading) {
  <div class="actions">
    @if (selectedPortalUser && selectedSsoUser) {
      <div>
        <section>
          <h3>
            <i class="fa fa-link"></i>Link
          </h3>
          <div class="display:flex;align-items:center">
            <p class="intro-text">Link {{selectedPortalUser}} to {{selectedSsoUser?.email}} ?</p>
            <button class="btn btn-primary btn-lg" (click)="linkSelected()">Activate</button>
          </div>
        </section>
      </div>
    }
    @if (!selectedSsoUser && selectedPortalUser?.portalStatus === PortalStatus.Activated) {
      <div>
        <section>
          <h3>
            <i class="fa fa-unlink"></i>Unlink
          </h3>
          <div class="display:flex;align-items:center">
            <p class="intro-text">Unlink {{selectedPortalUser}} ?</p>
            <button class="btn btn-primary btn-lg btn-block" (click)="unlinkSelected()">De-activate</button>
          </div>
        </section>
      </div>
    }
    @if (canLockSelectedPortalUser) {
      <div>
        <section>
          <h3>
            <i class="fa fa-lock"></i>Lock
          </h3>
          <div class="display:flex;align-items:center">
            <p class="intro-text">Lock {{selectedPortalUser}} ?</p>
            <button class="btn btn-primary btn-lg btn-block" (click)="lockSelectedPortalUser()">Lock</button>
          </div>
        </section>
      </div>
    }
    @if (canLockSelectedSsoUser) {
      <div>
        <section>
          <h3>
            <i class="fa fa-lock"></i>Lock
          </h3>
          <div class="display:flex;align-items:center">
            <p class="intro-text">Lock {{selectedSsoUser?.email}} ?</p>
            <button class="btn btn-primary btn-lg btn-block" (click)="lockSelectedSsoUser()">Lock</button>
          </div>
        </section>
      </div>
    }
    @if (canUnlockSelectedPortalUser) {
      <div>
        <section>
          <h3>
            <i class="fa fa-unlock-alt"></i>Unlock
          </h3>
          <div class="display:flex;align-items:center">
            <p class="intro-text">Unlock {{selectedPortalUser}} ?</p>
            <button class="btn btn-primary btn-lg btn-block" (click)="unlockSelectedPortalUser()">Unlock</button>
          </div>
        </section>
      </div>
    }
    @if (canUnlockSelectedSsoUser) {
      <div>
        <section>
          <h3>
            <i class="fa fa-unlock-alt"></i>Unlock
          </h3>
          <div class="display:flex;align-items:center">
            <p class="intro-text">Unlock {{selectedSsoUser?.email}} ?</p>
            <button class="btn btn-primary btn-lg btn-block" (click)="unlockSelectedSsoUser()">Unlock</button>
          </div>
        </section>
      </div>
    }
  </div>
}



@if (loading && loadingMessage) {
  <div>
    <div style="display:flex;align-items: center;">
      <div style="flex-grow:1"></div>
      <app-spinner [tiny]="true"></app-spinner>
      <label style="margin-left: 20px;">{{loadingMessage}}</label>
      <div style="flex-grow:1"></div>
    </div>
  </div>
}
@if (resultMessage) {
  <div>
    <div style="display:flex;align-items: center;">
      <div style="flex-grow:1"></div>
      @if (loading) {
        <app-spinner [tiny]="true"></app-spinner>
      }
      <label style="margin-left: 20px;">{{resultMessage}}</label>
      <div style="flex-grow:1"></div>
    </div>
  </div>
}
@if (validationErrors.length) {
  <div>
    @for (error of validationErrors; track error) {
      <div class="form-error" style="margin-bottom:10px;">{{error}}</div>
    }
  </div>
}



<!-- MAE-2: table for pre entry number search-->
@if ((preregUsers.length)) {
  <table class="table">
    <thead>
      <tr>
        <th>Forename</th>
        <th>Surname</th>
        <th>Role</th>
        <th>Pre-entry number</th>
        <th>Date of birth</th>
        <th>Email</th>
        <th>Qualification</th>
        <th>myGPhC</th>
        <th>Azure</th>
      </tr>
    </thead>
    <tbody>
      @for (user of preregUsers; track user) {
        <tr>
          <td>{{user.forenames}}</td>
          <td>{{user.surname}}</td>
          <td>@for (role of user.roles; track role; let i = $index; let isLast = $last) {
            <span style="display: block;">{{role.roleName}}{{isLast ? '' : ', '}}</span>
          }
        </td>
        <td>{{user.preEntry.preEntryNumber}}</td>
        <td>{{$safeNavigationMigration(user.contact?.dateOfBirth) | utcDate}}</td>
        <td>{{user.contact?.email || '-'}}</td>
        <td>@for (course of user.educations; track course; let i = $index; let isLast = $last) {
          <span style="display: block;">{{course.courseName}}{{isLast ? '' : ', '}}</span>
        }</td>
        <td>
          @if (user.checkingPortalStatus) {
            <span>
              <app-spinner [miniscule]="true"></app-spinner>
            </span>
          }
          @if (!user.gettingPortalStatus) {
            <span>
              {{PortalStatus[user.portalStatus] | caseSplit}}
            </span>
          }
        </td>
        <td>
          @if (user.checkingSsoStatus) {
            <span>
              <app-spinner [miniscule]="true"></app-spinner>
            </span>
          }
          @if (!user.checkingSsoStatus) {
            <span>
              {{SsoStatus[user.ssoStatus] | caseSplit}}
            </span>
          }
        </td>
      </tr>
    }
  </tbody>
</table>
}

@if (loadingStudent && loadingStudentMessage) {
  <div>
    <div style="display:flex;align-items: center;">
      <div style="flex-grow:1"></div>
      <app-spinner [tiny]="true"></app-spinner>
      <label style="margin-left: 20px;">{{loadingStudentMessage}}</label>
      <div style="flex-grow:1"></div>
    </div>
  </div>
}
@if (resultStudentMessage) {
  <div>
    <div style="display:flex;align-items: center;">
      <div style="flex-grow:1"></div>
      @if (loading) {
        <app-spinner [tiny]="true"></app-spinner>
      }
      <label style="margin-left: 20px;">{{res}}</label>
      <div style="flex-grow:1"></div>
    </div>
  </div>
}
@if (validationErrors.length) {
  <div>
    @for (error of validationErrors; track error) {
      <div class="form-error" style="margin-bottom:10px;">{{error}}</div>
    }
  </div>
}

<!--end of MAE-2 jira-->
